<script lang="ts">
  import type { GameServer } from "@/api";
  import { routeHref } from "@/router";
  import { servers, serverLimit, busyAction, runServerAction } from "@/stores/dashboard";
  import ServerList from "@/components/ServerList.svelte";
  import TextInput from "@/components/TextInput.svelte";

  let query = $state("");
  const filteredServers = $derived(
    $servers.filter((server) =>
      `${server.name} ${server.joinAddress} ${server.core}`
        .toLocaleLowerCase()
        .includes(query.trim().toLocaleLowerCase()),
    ),
  );

  function handleServerAction(server: GameServer, action: "start" | "stop") {
    void runServerAction(server, action);
  }
</script>

<header class="dashboard-intro">
  <div>
    <p class="eyebrow">Личная панель / инфраструктура</p>
    <h1>Серверы</h1>
    <p class="intro-copy">Управляй игровыми мирами, состояниями и доступом к ним.</p>
  </div>
  <a class="button" href={routeHref("server-create")}
    >Создать сервер <span aria-hidden="true">+</span></a
  >
</header>

{#if $servers.length > 0}
  <section class="server-search" aria-label="Поиск серверов">
    <label for="server-search">Найти сервер</label>
    <div class="search-controls">
      <TextInput
        id="server-search"
        type="search"
        density="comfortable"
        bind:value={query}
        placeholder="Название, адрес или сборка"
      />
      {#if query}<button class="ghost-button" type="button" onclick={() => (query = "")}
          >Сбросить</button
        >{/if}
    </div>
    <p role="status">Найдено: {filteredServers.length} из {$servers.length}</p>
  </section>
{/if}

{#if query.trim() && filteredServers.length === 0}
  <section class="panel-card search-empty">
    <h2>Сервер не найден</h2>
    <p>Попробуйте другое название, адрес или сборку.</p>
  </section>
{:else}
  <ServerList
    servers={filteredServers}
    serverLimit={$serverLimit}
    totalCount={$servers.length}
    busyAction={$busyAction}
    onAction={handleServerAction}
  />
{/if}

<style>
  .server-search {
    display: grid;
    gap: 0.6rem;
    margin-bottom: 1.5rem;
  }
  label {
    color: var(--muted);
    font-size: 0.85rem;
  }
  .search-controls {
    display: flex;
    gap: 0.75rem;
  }
  .server-search p {
    margin: 0;
    color: var(--muted);
    font-size: 0.85rem;
  }
  .search-empty {
    padding: 1.5rem;
  }
  @media (max-width: 420px) {
    .search-controls {
      flex-wrap: wrap;
    }
  }
</style>
